import { loadingAtom } from '../atoms/loadingAtom';
import { useSetAtom } from 'jotai';
import { type FC, type ReactNode, Suspense, useEffect } from 'react';

const Loading = () => {
  const setLoading = useSetAtom(loadingAtom);
  useEffect(() => {
    setLoading(true);
    return () => setLoading(false);
  }, [setLoading]);
  return null;
};

export const Susp: FC<{ readonly children: ReactNode }> = ({ children }) => {
  return <Suspense fallback={<Loading />}>{children}</Suspense>;
};
